__webpack_require__.p = "https://cdn.rivai-ic.com.cn/production/homepage/dist/";